import { useShipmentsApi } from "@/Hooks/useShipmentsApi";
import type { UUID } from "@/Shared/types";
import { updateBroker } from "@/Slices/bookShipmentSlice";
import BrokersBox from "@/Shared/Brokers/CustomComponents/BrokersBox";
import { useBrokersModifyBrokerDialog } from "@/Features/Brokers/Exports/Hooks/useBrokersModifyBrokerDialog";
import type { Broker } from "@freightsimple/generated-dashboard-openapi-client/models/Broker";

import { useDispatch } from "react-redux";
import { v4 as uuidv4 } from "uuid";

interface BookShipmentBrokerScreenAlreadySavedProps {
  broker: Broker;
  shipmentId: UUID;
  // savedBrokers: Array<SavedBroker>;
}

export function BookShipmentBrokerScreenAlreadySaved(
  props: BookShipmentBrokerScreenAlreadySavedProps,
) {
  const modifyBrokerDialog = useBrokersModifyBrokerDialog();
  const shipmentsApi = useShipmentsApi();
  const dispatch = useDispatch();
  //const savedBrokersApi = useSavedBrokersApi();

  // const [loading, setLoading] = useState(false);
  // const [brokers, setBrokers] = useState<undefined | Array<SavedBroker>>();

  // async function loadSavedBrokers() {
  //     setLoading(true);
  //     const savedBrokersResponse = await savedBrokersApi.getAllSavedBrokers();
  //     setBrokers(
  //         savedBrokersResponse.items.sort((a, b) => {
  //             return a.broker.businessName.localeCompare(
  //                 b.broker.businessName
  //             );
  //         })
  //     );

  //     setLoading(false);
  // }

  // useOnce(loadSavedBrokers);

  // function findSavedBrokerId() {
  //     const broker = props.broker;

  //     const matchingSavedBroker = props.savedBrokers.find(function (b) {
  //         return (
  //             b.broker.businessName === broker?.businessName &&
  //             b.broker.address.postalCode === broker.address.postalCode
  //         );
  //     });

  //     console.log(`!!! findSavedBrokerId`, { broker, matchingSavedBroker });

  //     return matchingSavedBroker?.savedBrokerId;
  // }

  //const savedBrokerId = findSavedBrokerId();

  // if (loading) {
  //     return <>Loading...</>;
  // }

  return (
    <div className="flex flex-col items-start">
      <BrokersBox
        key={"unnecessarykey"}
        broker={props.broker}
        onModify={async function () {
          // We don't particularly care which saved broker we are actually
          // using here
          const result = await modifyBrokerDialog.show({
            savedBrokerId: uuidv4(),
            broker: props.broker,
          });
          const updatedBroker = result?.broker;

          if (updatedBroker !== undefined) {
            await shipmentsApi.setBrokerDetails({
              setBrokerDetailsRequest: {
                shipmentId: props.shipmentId,
                broker: updatedBroker,
              },
            });
            dispatch(updateBroker(updatedBroker));
          }
        }}
        showMenu={false}
        onDelete={undefined}
        preferredNorthbound={false}
        preferredSouthbound={false}
        onSelectPreferred={undefined}
      />
      {modifyBrokerDialog.dialogs}
    </div>
  );
}
